// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Button */
.transparent_btn {
	display: inline-block;
	padding: 10px 14px;
	color: #FFF;
	border: 1px solid #FFF;
	text-decoration: none;
	font-size: 20px;
	line-height: 120%;
	background-color: rgba(255,255,255, 0);
	border-radius: 0px;
	transition: background-color 300ms ease;
	cursor: pointer;
}
.transparent_btn:hover {
	background-color: rgba(255,255,255, 0.3);
	color: #FFF;
}

body,html{
  height: 100%;
}

.blue-text {
  color: cornflowerblue;
  text-shadow: 2px, 2px , 10px, cornflowerblue ;
 }
`, "",{"version":3,"sources":["webpack://./src/app/practice/practice.component.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;CACC,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,sBAAsB;CACtB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,sCAAsC;CAGtC,kBAAkB;CAGlB,uCAAuC;CACvC,eAAe;AAChB;AACA;CACC,wCAAwC;CACxC,WAAW;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;CAC9C","sourcesContent":["/* Global Button */\r\n.transparent_btn {\r\n\tdisplay: inline-block;\r\n\tpadding: 10px 14px;\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #FFF;\r\n\ttext-decoration: none;\r\n\tfont-size: 20px;\r\n\tline-height: 120%;\r\n\tbackground-color: rgba(255,255,255, 0);\r\n\t-webkit-border-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\tborder-radius: 0px;\r\n\t-webkit-transition: background-color 300ms ease;\r\n\t-moz-transition: background-color 300ms ease;\r\n\ttransition: background-color 300ms ease;\r\n\tcursor: pointer;\r\n}\r\n.transparent_btn:hover {\r\n\tbackground-color: rgba(255,255,255, 0.3);\r\n\tcolor: #FFF;\r\n}\r\n\r\nbody,html{\r\n  height: 100%;\r\n}\r\n\r\n.blue-text {\r\n  color: cornflowerblue;\r\n  text-shadow: 2px, 2px , 10px, cornflowerblue ;\r\n }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
